import { useMutation, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"
import { TApiTask } from "../../api-client/types"
import { TApiGenericError } from "../../timenotes-query/timenotes-query.types"
import { ICreateProjectParams } from "../../api-client/projects-api"

interface Args extends Partial<ICreateProjectParams> {
  projectId: string
}

interface Result {
}

export const useUpdateProjectMutation = (options: any = {}) => {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const query = useMutation<Result, TApiGenericError<TApiTask>, Args>(
    ['project', 'update'],
    async (args: Args) => {
      const response = await apiClient.updateProject(args.projectId, args)

      if (!response.ok) {
        throw response.errors || {}
      }

      return {
        project: response.project
      }
    },
    {
      ...options,
      onSuccess: (data: Result, args: Args) => {
        queryClient.invalidateQueries('projects', { exact: false })
        queryClient.invalidateQueries(['project', args.projectId], { exact: false })
        queryClient.invalidateQueries(['projects-users', { projectId: args.projectId }], { exact: false })
        queryClient.invalidateQueries(["project-sections", args.projectId])

        if (options.onSuccess) {
          options.onSuccess(data, args)
        }
      },
    },
  )

  return query
}


export default useUpdateProjectMutation